// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/mounting-kit-for-dialysis-machines/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteMountingKitForDialysisMachinesEN: PageEntry = {
  id: "example.produkte-montageset-fuer-dialysegeraete",
  locale: "en",
  slug: "produkte/mounting-kit-for-dialysis-machines",
  seo: {
    title: "Mounting kit for dialysis machines | Dietz GmbH",
    description: "Spring made of tantalum wire as a functional element in the dialysis machine Compression springs are subjected to a 100% test and then assembled with the plastic components. In ord",
  },
  type: "post",
  h1: "Mounting kit for dialysis machines",
  intro: "Spring made of tantalum wire as a functional element in the dialysis machine Compression springs are subjected to a 100% test and then assembled with the plastic components. In order to simplify the later installation in the devices, mounting sets are put together at Dietz.",
  blocks: [
    { kind: "image", src: "/images/live/dtz-montagesetzDialyse.jpg", alt: "Mounting kit for dialysis machines", width: 1400, height: 1120 }
  ],
};
